export default function Modal({ children, className }) {
	
	return (
		<dialog className={className} open>
			{children}
		</dialog>
	)
}